const destinacoes = [
    {label: "Uso e consumo", value: "consumo"},
    {label: "Revenda", value: "revenda"}
];

export default destinacoes;